@if (loadingOptions()) {
    <tapestry-spinner [spinnerSize]="spinnerSize" />
}
<tapestry-select
    [selectLabel]="selectLabel()"
    [options]="languages()"
    [size]="size()"
    [isRequired]="isRequired()"
    [(ngModel)]="value"
    (ngModelChange)="onValueChange($event)"
    [disabled]="loadingOptions()"
/>
